import Briefing from "views/Briefing.js"
import Buses from "views/Buses.js"
import Dashboard from "views/Dashboard.js"
import Orders from "views/Orders.js"
import UserProfile from "views/UserProfile.js"
import Warehouse from "views/Warehouse.js"

import EDI from "views/tools/EDI.js"
import PricePredictor from "views/tools/PricePredictor"
import Signature from "views/tools/Signature.js"
import Tools from "views/tools/Tools.js"

import AlertsMainView from "views/alerts"
import Customers from "views/Customers"
import KPIs from "views/KPIs"
import AutomationMain from "views/tools/automation/AutomationMain"
import Trends from "views/trends"
import Trips from "views/trips"
import { LogsMainView } from "./views/logs"
import UserManagement from "./views/UserManagement"
import InvoiceToExcel from "views/tools/InvoiceToExcel.js"
import { createViewPagePermission } from "utils/pageAccess"

const withPageAccess = (route) => ({
  ...route,
  requiredPermission: route.publicAccess
    ? null
    : Object.prototype.hasOwnProperty.call(route, "requiredPermission")
      ? route.requiredPermission
      : createViewPagePermission(route.permissionName || route.name),
})

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: Dashboard,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/briefing",
    name: "Briefing",
    icon: "nc-icon nc-notes",
    component: Briefing,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/alerts",
    name: "Alerts",
    icon: "nc-icon nc-bell-55",
    component: AlertsMainView,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/orders",
    name: "Orders",
    icon: "nc-icon nc-delivery-fast",
    component: Orders,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/buses",
    name: "Buses",
    icon: "nc-icon nc-bus-front-12",
    component: Buses,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/warehouse",
    name: "Warehouse",
    icon: "nc-icon nc-app",
    component: Warehouse,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/trips",
    name: "Trips",
    icon: "nc-icon nc-vector",
    component: Trips,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/kpis",
    name: "KPIs",
    icon: "nc-icon nc-chart-pie-36",
    component: KPIs,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/trends",
    name: "Trends",
    icon: "nc-icon nc-chart-bar-32",
    component: Trends,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/customers",
    name: "Customers",
    icon: "nc-icon nc-bank",
    component: Customers,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/logs",
    name: "Logs",
    icon: "nc-icon nc-align-left-2",
    component: LogsMainView,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/tools",
    name: "Tools",
    icon: "nc-icon nc-grid-45",
    component: Tools,
    layout: "/admin",
    publicAccess: true,
  },
  {
    path: "/app/signature-generator",
    name: "Signature Generator",
    icon: "",
    component: Signature,
    layout: "/admin",
    hide: true,
  },

  {
    path: "/app/edi",
    name: "EDI Integrations Manager",
    icon: "",
    component: EDI,
    layout: "/admin",
    hide: true,
  },

  //Automations
  {
    path: "/app/automations",
    name: "Automations",
    icon: "",
    component: AutomationMain,
    layout: "/admin",
    hide: true,
  },
  // pricing mode
  {
    path: "/app/price-predictor",
    name: "Price Predictor",
    icon: "",
    component: PricePredictor,
    layout: "/admin",
    hide: true,
  },
  // Settings views
  {
    path: "/settings",
    name: "Settings",
    icon: "nc-icon nc-preferences-circle-rotate",
    component: UserProfile,
    layout: "/admin",
  },
  {
    path: "/users",
    name: "Users",
    icon: "nc-icon nc-single-02",
    component: UserManagement,
    layout: "/admin",
  },
  {
    path: "/app/invoice-to-excel",
    name: "Invoice to Excel",
    icon: "",
    component: InvoiceToExcel,
    layout: "/admin",
    hide: true,
  },
].map(withPageAccess)

export default dashboardRoutes
